module.exports = __webpack_public_path__ + "img/ic_arrow_down.8a4c2095.svg";